<template>
    <div
        :class="{ active }"
        class="full-page-loader"
    >
        <ProgressSpinner
            class="loader"
            mode="indeterminate"
        />
        <span
            v-if="message"
            class="message"
        >{{ message }}</span>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import { useEventBus } from '@vueuse/core'

const active = ref(false)
const message = ref('')

useEventBus('page-loader').on((val) => {
    if (val === false) {
        active.value = false
        message.value = ''
    } else if (typeof val === 'string') {
        message.value = val
    } else {
        active.value = true
    }
})
</script>

<style lang="sass" scoped>
.full-page-loader
    width: 100vw
    height: 100vh
    position: fixed
    top: 0
    left: 0
    z-index: var(--layer-page-loader)
    transition: opacity 0.5s ease-in-out
    opacity: 0
    pointer-events: none
    background-color: var(--tl-color-base-white)
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    gap: 16px
    .loader
        --p-progressspinner-color-one: var(--tl-color-base-black)
        align-self: center
        transition: 0.3s ease-in-out
        transition-delay: 0s
        transform: translateY(50vh)
        opacity: 0
    .message
        opacity: 0
        transition: opacity 0.3s ease-in-out
        transition-delay: 0s
        font-size: 14px
        color: var(--tl-color-text-secondary)
    &.active
        opacity: 1
        pointer-events: all
        transition: none
        .loader
            transition-delay: .4s
            transform: translateY(0)
            opacity: 1
        .message
            opacity: 1
            transition-delay: .6s
</style>
